import React from 'react';
export default function StarWandSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="18" y="16" width="4" height="22" rx="2" fill="#8D6E63" />
      <polygon points="20,2 23,10 32,10 25,15 27,24 20,19 13,24 15,15 8,10 17,10" fill="#FFD54F" />
      <polygon points="20,6 22,11 27,11 23,14 24,19 20,16 16,19 17,14 13,11 18,11" fill="#FFF8E1" />
    </svg>
  );
}
